import CryptoJS from "crypto-js";

export function decryptOTP(encryptedOTP) {
  const secretKey =
    "django-insecure-faklg!)(4+lith6a6f*jpgz3q4ytbby4sbqk^1)!@9#cu#sc64"; // Make sure this matches the backend's secret key

  const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedOTP);

  const iv = CryptoJS.lib.WordArray.create(
    encryptedBytes.words.slice(0, 4),
    16
  );

  const encryptedMessage = CryptoJS.lib.WordArray.create(
    encryptedBytes.words.slice(4)
  );

  const key = CryptoJS.SHA256(secretKey);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encryptedMessage },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  const decryptedOTP = decrypted.toString(CryptoJS.enc.Utf8);

  return decryptedOTP;
}
